"use strict";

/**
 * import
 */
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import smoothscroll from "smoothscroll-polyfill";
import * as accordion from "./libs/_accordion";
import * as lock from './libs/_scrollLock';
import * as tab from './libs/_tab';
gsap.registerPlugin(EaselPlugin, ScrollTrigger);
//require("intersection-observer");


/**
 * variable
 */
const mediaQuery = matchMedia("screen and (min-width: 768px)");
let beforeY = 0;
let header = document.querySelector(".header");
let headerLink = document.querySelectorAll(".header-list__link.js-accordion");



// accordion
accordion.init();


/**
 * DOMContentLoaded
 */

document.addEventListener(
  "DOMContentLoaded",
  () => {
    if(window.innerWidth < 768) {
      //fixHeader();

      headerLink.forEach(el => {
        el.href = "javascript:void(0)";
      });
    }
  },
  false
);

/**
 * load
 */
window.addEventListener(
  'load',
  () => {
    document.querySelector("body").classList.add("loaded");
  },
  false
);


/**
 * header
 */

// メニュー展開
document.querySelectorAll(".header-menu, .header-links").forEach(target => {
  target.addEventListener("click", () => {
    document.querySelector(".header").classList.toggle("is-header-active");
    lock.scrollLock();
    if(header.classList.contains("is-header-active")) header.classList.add("menu-open");
  });
});

/**
 * scroll
 */
let timeoutId ;
window.addEventListener(
  "scroll",
  () => {
    onScroll();
    if(window.innerWidth < 768) {
      //fixHeader();
      document.querySelector(".header").classList.remove("is-active");

      // スクロールを停止して500ms後に終了とする
      clearTimeout( timeoutId ) ;

      timeoutId = setTimeout( function () {
        document.querySelector(".header").classList.add("is-active");
      }, 500 ) ;
    }
  },
  false
);



/**
 * resize
 */
window.addEventListener(
  "resize",
  () => {
    if(window.innerWidth < 768) {
      //fixHeader();

      headerLink.forEach(el => {
        el.href = "javascript:void(0)";
      });
    }
  },
  false
);

function setClass(el, className, action) {
  if(typeof el != "object") el = document.querySelector(el);
  if(action == "add") {
    if(!el.classList.contains(className)) el.classList.add(className);
  }
  else if(action == "remove") {
    if(el.classList.contains(className)) el.classList.remove(className);
  }
}


changeMediaQuery(mediaQuery);
// ウィンドウサイズが変更されても実行されるように
mediaQuery.addListener(changeMediaQuery);
function changeMediaQuery(mq) {
  if (mq.matches) {
    // PC
    document.body.classList.add("is-pc");
    document.body.classList.remove("is-sp");
  }
  else {
    // SP
    document.body.classList.add("is-sp");
    document.body.classList.remove("is-pc");
    // kv
    // スクロールするとvhが変わってしまう問題を解決
    changeKvHeight();
    window.addEventListener("resize", changeKvHeight);
  }
}

/**
 * height
 */

function changeKvHeight() {
  document.querySelectorAll(".js-height").forEach((target) => {
    target.style.height = `${window.outerHeight}px`;
  });

  //ScrollTrigger.refresh();
}

setupVh();
function setupVh() {
  const mediaQuery = window.matchMedia("screen and (min-width: 768px)");
  mediaQuery.addEventListener("change", setProperty);

  setProperty();

  function setProperty() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    // const ratio = 1312 / 768;
    // document.documentElement.style.setProperty(
    //   "--vh",
    //   window.innerHeight / window.innerWidth > ratio
    //     ? `${vh}px`
    //     : `${ratio}vw`
    // );
  }
}



/* 下スクロール時は非表示、上スクロールで表示 */
function onScroll() {
  if(header.classList.contains("menu-open")) {
    header.classList.remove("menu-open");
    return;
  }
  else {
    let currentY = document.documentElement.scrollTop || document.body.scrollTop;
    if(currentY == 0) {
      if(header.classList.contains("scroll")) header.classList.remove("scroll");
    }
    else {
      if(currentY < beforeY || currentY == beforeY) {
        // up
        if(header.classList.contains("scroll")) header.classList.remove("scroll");
      }
      else {
        // down
        if(!header.classList.contains("scroll")) header.classList.add("scroll");
      }
    }
    beforeY = currentY;
  }
};





/* SP時 CVボタン追従
function fixHeader() {
  ScrollTrigger.matchMedia({
    "(max-width: 767px)": function() {
      ScrollTrigger.create({
        trigger: ".header-btns",
        startTrigger: "body",
        start: "bottom top",
        endTrigger: ".container",
        end: "bottom bottom-=60px",
        pin: true,
        //pinSpacing: false,
        invalidateOnRefresh: true,
      });
    }
  });
}
  */

/**
 * scroll
 */

// スムーススクロール
smoothscroll.polyfill();

document.querySelectorAll(`a[href*="#"]`).forEach((link) => {
  link.addEventListener("click", (e) => {
    const target = e.currentTarget;
    e.preventDefault();
    const targetId = target.hash;
    var href = target.href;
    var currentURL = location.href;
    if(currentURL.indexOf("#") > -1)  currentURL = currentURL.split("#")[0];
    if(href.split("#")[0] != currentURL) {
      window.location.href = href;
    }
    else {
      var param = href.substring(href.indexOf("?"));

      if(target.hasAttribute("target") && target.getAttribute("target") == "_blank") {
        open( target.href, "_blank" ) ;
      }
      else {
        if (href.indexOf("?") > -1) {
          location.href = href.replace(param, "");
        }
        else {
          if(href.indexOf(currentURL) == -1 || location.pathname == "/" || href.split("#")[0] !== currentURL) {
            location.href = href;
          }
          else if(href.indexOf(currentURL) > -1) {
            const targetElement = document.querySelector(targetId);
            // 画面上部から要素までの距離
            const rectTop = targetElement.getBoundingClientRect().top;
            // 現在のスクロール距離
            const offsetTop = window.pageYOffset;
            //スクロール位置に持たせるバッファ
            const top = rectTop + offsetTop;

            window.scrollTo({
              top,
              behavior: "smooth",
            });
          }
        }
      }
    }
  });
});


// IEでスムーススクロールを無効に
if (document.documentMode) {
  document.querySelector(`body`).addEventListener("mousewheel", (event) => {
    event.preventDefault();
    let wd = event.wheelDelta;
    let csp = window.pageYOffset;
    window.scrollTo(0, csp - wd);
  });
}


const fade = document.querySelectorAll(".fade");
fade.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("on");
    },
  });
});

const fadein = document.querySelectorAll(".fadein");
fadein.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("on");
    },
  });
});

const anim = document.querySelectorAll(".anim");
anim.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("exit");
    },
  });
});


const anim02 = document.querySelectorAll(".anim02");
anim02.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 25%",
    once: true,
    onEnter: () => {
      item.classList.add("exit");
    },
  });
});

const link = document.querySelectorAll(".link");
link.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("on");
    },
  });
});


if(document.querySelector(".subpage-kv__circles--fixed")) {
  gsap.to('.subpage-kv__circles--fixed', {
    opacity: 0.2,
    scrollTrigger: {
      trigger: 'main',
      start: 'top top',
      end: 'bottom bottom',
      scrub: true,
      pin: '.subpage-kv__circles--fixed'
    }
  });
  gsap.to('.subpage-kv__circle--02', {
    opacity: 0.1,
    scale: 1,
    scrollTrigger: {
      trigger: 'main',
      start: '600px center',
    }
  });
  gsap.to('.subpage-kv__circle--03', {
    opacity: 0.1,
    scale: 1,
    scrollTrigger: {
      trigger: 'main',
      start: '900px center',
    }
  });
}

/*
ScrollTrigger.create({
  trigger: "#TOP",
  start: "bottom bottom",
  endTrigger: "footer",
  end: "bottom bottom-=60px",
  toggleClass: {
    targets: ".footer-back",
    className: "active"
  },
});
*/
